import React, { Suspense, useEffect } from "react";

import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";

import { BehaviorsProvider } from "../utils/behaviors";
import { SDKProvider } from "../utils/sdk";
import { TranslationProvider } from "../utils/translation";
import { WebmessengerProvider } from "../utils/webmessenger";
import { WebSocketProvider } from "../utils/websocket";

const App = React.lazy(() => import("./App"));

function Index() {
    useEffect(() => {
        async function init() {
            const fingerprint = await getFingerprint();

            window.eK.fingerprint = fingerprint;
            if (process.env.REACT_APP_ANALYTICS) {
                try {
                    const data = {
                        fingerprint,
                        integration: window.eK.integration,
                        entity: window.eK.entity,
                        url: window.location.href,
                    };

                    await fetch(`${process.env.REACT_APP_ANALYTICS}/pageView`, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        }

        init();
    }, []);

    return (
        <TranslationProvider>
            <WebmessengerProvider>
                <BehaviorsProvider>
                    <WebSocketProvider uri={process.env.REACT_APP_WEBSOCKET}>
                        <Suspense fallback={<span />}>
                            <SDKProvider
                                ref={(ref) => {
                                    window.__ekwm = ref;
                                }}
                            >
                                <App />
                            </SDKProvider>
                        </Suspense>
                    </WebSocketProvider>
                </BehaviorsProvider>
            </WebmessengerProvider>
        </TranslationProvider>
    );
}

export default Index;
